<template>
  <div class="email-teacher-schedules">
    <label>
      Email Address:
      <input v-model="emailAddress" type="email" />
    </label>
    <button @click="generateEmailContent()">Send Schedule</button>
    <div ref="schedulePreview">
      <h1>Schedule for {{ row.name }}</h1>
      <h2>
        Date Range: {{ formatDate(dateRange.start) }} to
        {{ formatDate(dateRange.end) }}
      </h2>
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in row.items" :key="item.index">
            <td v-for="detail in item.details" :key="detail.scheduleId">
              {{ formatDate(detail.startTime) }}
              {{ formatTime(detail.startTime) }}
              {{ formatTime(detail.endTime) }}
              {{ detail.notes || "N/A" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailTeacherSchedules",
  props: {
    row: {
      type: Object,
      required: true,
    },
    dateRange: {
        type: Object,
        required: true
    }
  },
  data() {
    return {
      emailAddress: "",
    };
  },
  methods: {
    formatDate(dateString) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    formatTime(dateString) {
      const options = { hour: "2-digit", minute: "2-digit", hour12: false };
      return new Date(dateString).toLocaleTimeString(undefined, options);
    },
    generateEmailContent() {
      const emailContent = this.$refs.schedulePreview.innerHTML;
console.log(emailContent)
      // Assume sendEmailService is a service that sends the email
      // with the email content we just generated
    //   sendEmailService(this.emailAddress, emailContent)
    //     .then(() => alert("Email sent successfully!"))
    //     .catch((err) => alert("Failed to send email: " + err.message));
    },
  },
};
</script>

<style scoped>
.email-teacher-schedules {
  /* Add any necessary styling here */
}
</style>
